import styles from './TextMessage.module.scss'
import { TextMessageProps } from '@commons/text-message/types.ts'

const TextMessage = ({ data, referral }: TextMessageProps) => {
    return (
        <div>
            <div
                className={styles.textMessage}
                role="region"
                aria-labelledby="text-message-title">
                <div className={styles.textMessage__title}>
                    <h3 id="text-message-title">{data.heading}</h3>
                </div>
                <div className={styles.textMessage__text}>
                    <p>
                        {data.text}{' '}
                        {referral && (
                            <strong className={styles.textMessage__referral}>
                                {referral}
                            </strong>
                        )}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TextMessage
